module.exports = {"420582001":"当阳市玉阳街道","420582002":"当阳市坝陵街道","420582003":"当阳市玉泉街道","420582101":"当阳市两河镇","420582102":"当阳市河溶镇","420582103":"当阳市淯溪镇","420582104":"当阳市庙前镇","420582105":"当阳市王店镇","420582106":"当阳市半月镇","420582107":"当阳市草埠湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420582.json
// module id = 1736
// module chunks = 0